import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-2xl mx-auto text-center">
        <p className="font-heading text-7xl md:text-9xl font-black text-primary-100 select-none">
          404
        </p>
        <h1 className="mt-4 font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm text-foreground-500">
          您访问的页面不存在或已下线
        </p>
        <p className="mt-1 text-xs text-foreground-400 font-mono break-all">{location.pathname}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold px-6 py-3 rounded-md cursor-pointer whitespace-nowrap transition-colors"
          >
            <i className="ri-home-4-line" aria-hidden="true"></i>
            返回首页
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-2 border border-background-300 hover:border-primary-400 text-foreground-700 text-sm font-semibold px-6 py-3 rounded-md cursor-pointer whitespace-nowrap transition-colors"
          >
            <i className="ri-search-line" aria-hidden="true"></i>
            去搜索影视
          </Link>
        </div>
      </div>
    </div>
  );
}